<template>
  <div v-if="show">
    <Modal :mask-closable="false" v-model="show" :title="title" width="1200px">
      <table class="QHtable">
        <tr>
          <th class="strong">专利信息</th>
          <th colspan="10" class="QHbtnML10">
            <span class="CL5" v-if="$isArr(row.id, $store.state.carCount.isGuanzhu || [])"><i class="iconfont icon-shoucang1"></i>已加入购物车</span>
            <Button type="primary" v-if="$isArr(row.id, $store.state.carCount.isGuanzhu || [])" @click="$onOffGuanzhu(row, 'yiGuanzhu')">移除购物车</Button>
            <Button type="success" v-else-if="$isArr(row.status, '100,200,300')" @click="$onOffGuanzhu(row, 'weiGuanzhu')">加入购物车</Button>
          </th>
        </tr>
        <tr>
          <td class="strong"><b>专利名称</b></td>
          <td colspan="10">
            <span class="MR5 CL5" v-if="row.is_del == 1">专利已删除</span>
            <span class="MR5 CL5" v-if="row.status == 400">专利已售出</span>
            <span class="MR5 CL5" v-if="row.status == 500">专利已下架</span>
            <span class="MR5">{{ $s("zhuanKind", row.kind) }}</span>
            <span class="MR5">{{ $s("zhuanType", row.type) }}</span>
            <span class="MR5">{{ row.applicationNumber }}</span>
            <span>{{ row.title }}</span>
          </td>
        </tr>
        <tr v-if="row.pdf">
          <td class="strong"><b>专利文件</b></td>
          <td colspan="10">
            <QHfileListShow :values="row.pdf" :isRemove="false"></QHfileListShow>
          </td>
        </tr>
        <tr v-if="row.keyword">
          <td class="strong"><b>技术词语</b></td>
          <td colspan="10">{{ row.keyword }}</td>
        </tr>
        <tr v-if="row.summary">
          <td class="strong"><b>专利摘要</b></td>
          <td colspan="10">{{ row.summary }}</td>
        </tr>
        <tr v-if="row.expenseNote">
          <td class="strong"><b>官费时间</b></td>
          <td colspan="10">{{ row.expenseNote }}</td>
        </tr>
        <tr>
          <td class="strong"><b>专利价格</b></td>
          <td colspan="10">
            <span class="MR5 hotFont14">{{ $amount(row.price) }}</span>
          </td>
        </tr>
      </table>
      <div slot="footer">
        <Button type="info" @click="$refs.OskefuCG.hello('联系客服预定➥' + row.title)">联系我们预定</Button>
      </div>
    </Modal>
    <OskefuCG ref="OskefuCG"></OskefuCG>
  </div>
</template>

<script>
import OskefuCG from "@/components/OskefuCG/OskefuCG";
export default {
  components: {
    OskefuCG,
  },
  // +----------------------------------------------------------------------
  // | Desc:data
  // +----------------------------------------------------------------------
  data() {
    return {
      title: "",
      show: false,
      order_id: "",
      row: {},
    };
  },

  methods: {
    // +----------------------------------------------------------------------
    // | Desc:刷新三方刷新国知局数据
    // +----------------------------------------------------------------------
    getGZstc(applicationNumber) {
      var that = this;
      this.$getGZstc(applicationNumber, function (res) {
        that.hiPop(that.row.id, that.order_id, true);
        that.$msg("刷新成功", "success");
      });
    },

    // +----------------------------------------------------------------------
    // | Desc:唤起详情
    // +----------------------------------------------------------------------
    hiPop(id, order_id, isRelist) {
      var that = this;

      that.order_id = order_id;
      var https = {
        type: "isRow",
        api: this.$api.getCGYXDetaild,
        parameter: {
          id: id,
        },
      };
      this.$httpsApi(https, function (res) {
        that.title = res.data.title;
        that.show = true;
      });

      //更新列表
      if (isRelist) {
        this.$emit("success");
      }
    },
  },
};
</script>
<style>
.OsOrderList.yes {
  opacity: 1;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  padding: 10px;
  border-radius: 10px;
  border: 2px solid #515a6e;
}
</style>
